<template>
	<div>
		<vs-table search stripe :data="containers" >
			<template slot="header">
				<h1>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
						Contenedor<br>
					</vs-col>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
						<vs-button @click="createContainerPrompt()" radius color="success" type="border" icon="add"></vs-button>
					</vs-col>
					<vs-prompt @cancel="val=''" @accept="createContainer" :active.sync="activePrompt2" title="Crear Contenedor" :is-valid="validName">
						<div class="con-exemple-prompt">
							<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
								<vs-input size="small" label="Tipo" v-model="type"/>
								<vs-input size="small" label=" Tara (Kg)" v-model="tareWeight" type="tareWeight"/>
								<vs-input size="small" label="Peso (Kg)" v-model="weight"/>
								<vs-input size="small" label="Volumen (Mts3)" v-model="volume"/>
							</vs-col>
							<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
								<vs-input size="small" label="Largo (Mts)" v-model="width"/>
								<vs-input size="small" label="Ancho (Mts)" v-model="long"/>
								<vs-input size="small" label="Alto (Mts)" v-model="high"/>
								<vs-input size="small" label="Observación" v-model="observation"/>
								<vs-alert :active="!validName" color="danger" icon="new_releases" class="emptyWarning">
									Completar campos
								</vs-alert>
							</vs-col>
						</div>
					</vs-prompt>
					
				</h1>
			</template>
			<template slot="thead">
				<vs-th>
					Tipo
				</vs-th>
				<vs-th>
					Peso (Kg)
				</vs-th>
				<vs-th>
					Volumen (Mts3)
				</vs-th>
				<vs-th>
					Observación
				</vs-th>
				<vs-th>
					Editar
				</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].type">
						{{data[indextr].type}}
						<!-- <template slot="edit">
							<vs-input v-model="data[indextr].type" class="inputx" placeholder="Tipo"/>
						</template> -->
					</vs-td>

					<vs-td :data="data[indextr].weight">
						{{data[indextr].weight}}
					</vs-td>

					<vs-td :data="data[indextr].volume">
						{{data[indextr].volume}}
					</vs-td>

					<vs-td :data="data[indextr].observation">
						{{data[indextr].observation}}
					</vs-td>

					<vs-td :data="data[indextr].id">
						<vs-button  @click="editContainerPrompt(tr)" vs-type="gradient" size="small" color="success" icon="edit"></vs-button>
						<vs-prompt @cancel="val=''" @accept="editContainer" :active.sync="activePrompt" title="Editar Contenedor">
							<div class="con-exemple-prompt">
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
									<vs-input size="small" label="Tipo" v-model="type"/>
									<vs-input size="small" label=" Tara (Kg)" v-model="tareWeight" type="tareWeight"/>
									<vs-input size="small" label="Peso (Kg)" v-model="weight"/>
									<vs-input size="small" label="Volumen (Mts3)" v-model="volume"/>
								</vs-col>
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
									<vs-input size="small" label="Largo (Mts)" v-model="width"/>
									<vs-input size="small" label="Ancho (Mts)" v-model="long"/>
									<vs-input size="small" label="Alto (Mts)" v-model="high"/>
									<vs-input size="small" label="Observación" v-model="observation"/>
								</vs-col>
							</div>
						</vs-prompt>
					</vs-td>
					<template class="expand-user" slot="expand">
							<vs-list>
								<vs-list-item icon="place" title="Tara (Kg)" :subtitle="tr.tareWeight.toString()"></vs-list-item>
								<vs-list-item icon="place" title="Largo (Mts)" :subtitle="tr.width.toString()"></vs-list-item>
								<vs-list-item icon="work" title="Ancho (Mts)" :subtitle="tr.long.toString()"></vs-list-item>
								<vs-list-item icon="clear_all" title="Alto (Mts)" :subtitle="tr.high.toString()"></vs-list-item>

							</vs-list>
							<div class="con-btns-user">
								<div>
									<vs-button @click="openConfirm(tr.id, tr.type)" vs-type="flat" size="medium" color="danger" icon="delete_sweep"></vs-button>
								</div>
							</div>
					</template>
				</vs-tr>
			</template>

    </vs-table>
	<!-- <pre>{{ selected }}</pre> -->

	</div>
</template>

<script>

export default {
	data(){
		return{
			containers : [],
			val:'Contenedor',
			activePrompt:false,
			activePrompt2:false,
			activeConfirm:false,
			idContainer: 0,
			type: "",
			width: "",
			high: "",
			long: "",
			weight: "",
			volume: "",
			tareWeight: "",
			observation: "",
		}
	},
	computed:{
		validName(){
			return (this.type.length > 0 && this.width.length > 0 && this.high.length > 0 && this.long.length > 0 && this.weight.length > 0 && this.volume.length > 0 && this.tareWeight.length > 0 && this.observation.length > 0 )
		}
	},
	methods: {
		getContainers(){
			const path = '/container/'
			this.$http.get(path).then((response) => {
				this.containers = response.data
				console.log(this.containers)
			})
			.catch((error) => {
				console.log(error)
			})
		},
		editContainer(){
			const path = `/container/${this.idContainer}/` 
			this.$http.patch(path, {
				type: this.type,
				width: this.width,
				high: this.high,
				long: this.long,
				weight: this.weight,
				volume: this.volume,
				tareWeight: this.tareWeight,
				observation: this.observation,
			})
			.then((response) => {
				console.log(response.data.results)
				this.getContainers()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:'Actualización de los datos del contenedor'
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser editado'
				})
			});
		},
		deleteContainer(){
			const path = `/container/${this.idContainer}/` 
			this.$http.delete(path).then((response) => {
				console.log(response.data)
				this.getContainers()
				this.$vs.notify({
					color:'danger',
					title:'Registro eliminado',
					text:`El registro fue eliminado correctamente`
				})
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser eliminado'
				})
			})
			
		},
		createContainer(){
			const path = `/container/`;
			
			this.$http.post(path, {
				type: this.type,
				width: this.width,
				high: this.high,
				long: this.long,
				weight: this.weight,
				volume: this.volume,
				tareWeight: this.tareWeight,
				observation: this.observation,
			})
			.then((response) => {
				console.log(response.data.results)
				this.getContainers()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:`Creación del contenedor ${this.type}`
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El contenedor no pudo ser creado'
				})
			});
		},
		openConfirm(id, c){
			this.idContainer = id,
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: `Confirmar`,
				text: `¿Desea eliminar al contenedor ${c}?`,
				accept:this.deleteContainer,
				acceptText:'Aceptar',
				cancelText:'Cancelar',
			})
		},
		editContainerPrompt(id){
			this.idContainer = id["id"];
			this.activePrompt = true;
			this.type= id["type"];
			this.width= id["width"];
			this.high= id["high"];
			this.long= id["long"];
			this.weight= id["weight"];
			this.volume= id["volume"];
			this.tareWeight= id["tareWeight"];
			this.observation= id["observation"];
		},
		createContainerPrompt(){
			this.idContainer = "";
			this.activePrompt2 = true;
			this.type= "";
			this.width= "";
			this.high= "";
			this.long= "";
			this.weight= "";
			this.volume= "";
			this.tareWeight= "";
			this.observation= "";
		},
	},
	created(){
		this.getContainers()
	}
}
</script>

<style lang="stylus">
.con-exemple-prompt
	padding 1px;
	padding-bottom 1px;
	.vs-input
		width 90%
		margin-top 1px;
.emptyWarning{
	width 90%;
	margin-top:10px;
}
</style>